import { isRejectedWithValue, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { redirect } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const rtkQueryErrorLogger: Middleware = (auth: MiddlewareAPI) => next => (action: any) => {
  if (isRejectedWithValue(action)) {
    if (action.payload.status === 401 || action.payload.status === 403) {
      console.log('Bad permissions');
      redirect('/');
    }
  }

  return next(action);
};
